<template>
    <div
        :style="configStyles"
        class="o-notification-modal notification-modal"
        @click.stop
    >
        <svg-icon
            original
            name="icons/path-2"
            class="notification-modal__path-icon"
        />
        <span class="notification-modal__headline">
            {{ $t('o-notification-modal_headline') }}
        </span>
        <span class="notification-modal__sub-headline">
            {{ $t('o-notification-modal_sub-headline') }}
        </span>
        <div class="notification-modal__countdown-block">
            <Countdown
                :time="timer"
                :transform="transform"
                class="notification-modal__countdown"
                @end="redirectToHome"
            >
                <template
                    #default="props"
                >
                    {{ props.seconds }}
                </template>
            </Countdown>
            <span class="notification-modal__countdown-tip">
                {{ $t('o-notification-modal_seconds') }}
            </span>
        </div>
        <span class="notification-modal__countdown-action-tip">
            {{ $t('ui.do-you-want-continue') }}
        </span>
        <AButton
            theme="primary"
            :text="$t('o-notification-modal_continue')"
            class="notification-modal__button notification-modal__button--black"
            @onClick="onClick"
        >
            <template #right>
                <svg-icon
                    original
                    name="icons/arrow-right"
                    class="notification-modal__arrow-icon"
                />
            </template>
            <template 
                v-if="isShowBlackLeftIcon"
                #left
            >
                <svg-icon
                    original
                    name="icons/path-2"
                    class="notification-modal__button-path-icon"
                />
            </template>
        </AButton>
        <AButton
            theme="secondary"
            :text="$t('o-notification-modal_cancel')"
            class="notification-modal__button notification-modal__button--white"
            @onClick="redirectToHome"
        >
            <template #left>
                <svg-icon
                    original
                    :name="`icons/${backIconName}`"
                    class="notification-modal__close-icon"
                />
            </template>
        </AButton>
        <div class="notification-modal__powered" >
            <span class="notification-modal__powered-text">Powered by</span>
            <svg-icon
                original
                name="icons/mvg-powered"
                class="notification-modal__powered-icon"
            />
        </div>
        
    </div>
</template>

<script>
import Countdown from '@chenfengyuan/vue-countdown';

import AButton from '../../atoms/a-button/a-button';

import {
    mapState,
    mapGetters
} from 'vuex'

import { START_SCREEN } from '@/utils/constants/pages';
import { TIMER_NOTIFICATION_POPUP } from '@/utils/constants/dates-time';
import {
    RESTORE_LOCALE,
    SESSION_EXTENDED,
    SESSION_TERMINATED
} from '@/utils/constants/bus-events-constants';

export default {
    name: 'ONotificationModal',
    components: {
        AButton,
        Countdown
    },
    data() {
        return {
            timer: TIMER_NOTIFICATION_POPUP
        }
    },
    computed: {
        ...mapState({
            countdownTimer: state => state.map.meta.countdown_timer
        }),
        ...mapGetters([
            'getMapConfigProp'
        ]),
        configStyles() {
            return this.getMapConfigProp('components.ONotificationModal.styles') || {};
        },
        configParams() {
            return this.getMapConfigProp('components.ONotificationModal.params') || {};
        },
        isShowBlackLeftIcon() {
            return this.configParams.is_show_back_left_icon
        },
        backIconName() {
            return this.configParams.back_icon_name || 'close'
        }
    },
    mounted() {
        this.timer = this.countdownTimer*1000 || TIMER_NOTIFICATION_POPUP
    },
    methods: {
        transform(props) {
            Object.entries(props).forEach(([key, value]) => {
                // Adds leading zero
                const digits = value < 10 ? `0${value}` : value;
                props[key] = `${digits}`;
            });

            return props;
        },
        onClick() {
            this.$emit('onClose', true);
            this.$bus.$emit(SESSION_EXTENDED, true);
        },
        redirectToHome() {
            const params = {
                name: START_SCREEN
            };
            this.$router.push(params);
            this.$emit('onClose', true);
            this.$bus.$emit(SESSION_TERMINATED, true);
            this.$bus.$emit(RESTORE_LOCALE, true);
        }
    }
}
</script>

<style lang="scss">
@import "o-notification-modal";
</style>
